export default "__VITE_ASSET__vnhTVHyt__"